import React, { useContext } from 'react';
import { MenuList } from '@/components/menuList';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem } from '@chakra-ui/react';
import { MdAdd, MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import { SharedExperiencePageContext } from '../lib/sharedExperiencePageContext';
import DeleteSharedExperienceModal from '../../components/deleteSharedExperienceModal';
import useTranslation from '../../../lib/i18n/useTranslation';

export default function SharedExperienceAsideEditMenu() {
  const { t } = useTranslation();
  const {
    sharedExperience,
    rights,
  } = useContext(SharedExperiencesContext);
  const {
    sharedExperienceList,
    setAddingSharedExperience,
  } = useContext(SharedExperiencePageContext);
  const modalDelete = useDisclosure();
  
  return (
    <>
      {rights && (
        <Menu>
          {({ isOpen }) => (
            <>
              <MenuButton
                isActive={isOpen}
                as={IconButton}
                icon={<MdMoreHoriz />}
                variant="greenOutline"
              />
              <MenuList fontSize={"14px"}>
                {(!sharedExperienceList || sharedExperienceList.length === 0) && rights.can_update && (
                  <MenuItem onClick={() => {
                    setAddingSharedExperience(true);
                  }}>
                    <Icon
                      as={MdAdd}
                      boxSize={'14px'}
                      mr={2}
                    />
                    {t('sharedExperience.addSharedExperience')}
                  </MenuItem>
                )}
                {rights.can_delete && (
                  <MenuItem onClick={() => {
                    modalDelete.onOpen();
                  }}>
                    <Icon
                      as={MdOutlineDelete}
                      color='text.medium.red'
                      boxSize={'14px'}
                      mr={2}
                    />
                    <Text color='text.medium.red'>{t('common.delete')}</Text>
                    <DeleteSharedExperienceModal disclosure={modalDelete} />
                  </MenuItem>
                )}
              </MenuList>
            </>
          )}
        </Menu>
      )}
    </>
  )
} 